<script setup>
import { ref } from 'vue'
import { params } from '@/components/Ajuda/Montador/composables/useBuilderState'

const emit = defineEmits(['create-combo'])

const obstacleOptions = [
  { value:'vertical',  label:'Vertical' },
  { value:'oxer',      label:'Oxer' },
  { value:'tripleBar', label:'Triple Bar' },
  { value:'gate',      label:'Gate' },
  { value:'plank',     label:'Plank' },
  { value:'wall',      label:'Muro' },
]

const dDefault = params?.combos?.defaultCentro ?? 7.5

// Duplo
const t2 = ref(['vertical','vertical'])
const d2 = ref(dDefault)

// Triplo
const t3 = ref(['vertical','vertical','vertical'])
const d31 = ref(dDefault)
const d32 = ref(dDefault)

function makeDuplo() {
  emit('create-combo', { types: t2.value.slice(), distances: [Number(d2.value || 0)] })
}
function makeTriplo() {
  emit('create-combo', { types: t3.value.slice(), distances: [Number(d31.value || 0), Number(d32.value || 0)] })
}
</script>

<template>
  <div class="section">
    <label class="label">Combos</label>

    <!-- Duplo -->
    <div class="section-subtitle">Duplo</div>
    <div class="row">
      <select v-model="t2[0]">
        <option v-for="o in obstacleOptions" :key="'d2a-'+o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <select v-model="t2[1]">
        <option v-for="o in obstacleOptions" :key="'d2b-'+o.value" :value="o.value">{{ o.label }}</option>
      </select>
    </div>
    <div class="row">
      <label>Centro a centro (m)</label>
      <input type="number" step="0.1" v-model.number="d2" />
    </div>
    <div class="row">
      <button class="btn" @click="makeDuplo">Inserir Duplo</button>
    </div>

    <!-- Triplo -->
    <div class="section-subtitle" style="margin-top:10px">Triplo</div>
    <div class="row">
      <select v-model="t3[0]">
        <option v-for="o in obstacleOptions" :key="'t3a-'+o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <select v-model="t3[1]">
        <option v-for="o in obstacleOptions" :key="'t3b-'+o.value" :value="o.value">{{ o.label }}</option>
      </select>
    </div>
    <div class="row">
      <select v-model="t3[2]">
        <option v-for="o in obstacleOptions" :key="'t3c-'+o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <span />
    </div>
    <div class="row">
      <label>Centro a centro (m)</label>
      <input type="number" step="0.1" v-model.number="d31" />
      <input type="number" step="0.1" v-model.number="d32" />
    </div>
    <div class="row">
      <button class="btn" @click="makeTriplo">Inserir Triplo</button>
    </div>

    <div class="hint">
      O espaçamento face-a-face é ajustado automaticamente usando as espessuras/vãos dos tipos escolhidos.
    </div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
